module.exports = __webpack_public_path__ + "img/empty_image.93111fb9.png";